import { render, staticRenderFns } from "./IconSearch.vue?vue&type=template&id=3455c0be&"
import script from "./IconSearch.vue?vue&type=script&lang=js&"
export * from "./IconSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports